import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,

  props: ['labels', 'data'],

  data () {
    return {
      chartData: null,
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback (label) {
                if (Math.floor(label) === label) {
                  return label
                }
              }
            }
          }]
        }
      }
    }
  },

  mounted () {
    const randomColors = this.data.map(() => {
      return this.chartColors[Math.floor(Math.random() * this.chartColors.length)]
    })

    this.chartData = {
      labels: this.labels,
      datasets: [{
        data: this.data,
        backgroundColor: randomColors
      }]
    }

    this.renderChart(this.chartData, this.options)
  },

  computed: {
    chartColors () {
      return this.$store.getters.chartColors
    }
  }
}
